export const LOCAL_STORAGE_UTILS = {
  storeData: (key: string, data: string) => {
    localStorage.setItem(key, data);
  },
  retrieveData: (key: string) => {
    const data = localStorage.getItem(key);
    return data;
  },
};
